import { Link } from "react-router-dom";

export default function Logo({ className = "", size = "md" }) {
    const sizes = {
        sm: { box: "w-8 h-8", text: "text-lg", two: "text-2xl", monitor: "w-9 h-9" },
        md: { box: "w-10 h-10", text: "text-xl", two: "text-3xl", monitor: "w-11 h-11" },
        lg: { box: "w-12 h-12", text: "text-2xl", two: "text-4xl", monitor: "w-14 h-14" },
    };
    const s = sizes[size];
    return (
        <Link to="/" className={`flex items-center gap-2 group ${className}`} data-testid="site-logo">
            <div className={`relative ${s.box} rounded-lg flex items-center justify-center overflow-hidden`}
                style={{
                    background: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 55%, #0ea5e9 100%)",
                    boxShadow: "0 0 18px rgba(6,182,212,0.35), inset 0 0 0 1px rgba(255,255,255,0.15)",
                }}>
                {/* Concentric survey target + CAD mark — represents "Surveys" */}
                <svg viewBox="0 0 40 40" className="w-full h-full">
                    <defs>
                        <linearGradient id="logoG" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor="#ecfeff" stopOpacity="0.9" />
                            <stop offset="100%" stopColor="#f97316" stopOpacity="0.9" />
                        </linearGradient>
                    </defs>
                    <circle cx="20" cy="20" r="13" fill="none" stroke="#020617" strokeWidth="1.5" opacity="0.5" />
                    <circle cx="20" cy="20" r="8" fill="none" stroke="#ffffff" strokeWidth="1.3" />
                    <line x1="20" y1="4" x2="20" y2="36" stroke="#ffffff" strokeWidth="1.2" opacity="0.8" />
                    <line x1="4" y1="20" x2="36" y2="20" stroke="#ffffff" strokeWidth="1.2" opacity="0.8" />
                    <circle cx="20" cy="20" r="2.6" fill="url(#logoG)" />
                </svg>
            </div>
            <div className={`font-heading font-extrabold ${s.text} leading-none tracking-tight flex items-center`}>
                <span className="text-slate-50">Surveys</span>
                <span className={`text-cyan-400 neon-text font-black ${s.two} leading-none ml-0.5 mr-1`}>2</span>
                <span className={`${s.monitor} flex items-center justify-center`}>
                    <svg viewBox="0 0 40 40" className="w-full h-full">
                        <defs>
                            <linearGradient id="logoScreen2" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#0b1120" />
                                <stop offset="100%" stopColor="#020617" />
                            </linearGradient>
                            <linearGradient id="logoText2" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#67e8f9" />
                                <stop offset="100%" stopColor="#f97316" />
                            </linearGradient>
                        </defs>
                        {/* Monitor bezel */}
                        <rect x="3" y="6" width="34" height="22" rx="2.5"
                            fill="#020617" stroke="#ffffff" strokeWidth="1.6" />
                        {/* Screen */}
                        <rect x="5.5" y="8.5" width="29" height="17" rx="1" fill="url(#logoScreen2)" />
                        {/* CAD text — bold, same cyan as the "2" number */}
                        <text x="20" y="22.5" textAnchor="middle"
                            fontFamily="'Inter', 'Helvetica Neue', sans-serif"
                            fontSize="12" fontWeight="900" letterSpacing="0.6"
                            fill="#22d3ee">CAD</text>
                        {/* Monitor neck */}
                        <rect x="17.5" y="28" width="5" height="3.5" fill="#ffffff" />
                        {/* Monitor base */}
                        <rect x="11" y="31.5" width="18" height="2.2" rx="1.1" fill="#ffffff" />
                    </svg>
                </span>
            </div>
        </Link>
    );
}
